import React from 'react';

const ClinicalActivity = () => {
  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h3 className="text-lg font-medium mb-3">Clinical Activity</h3>
      
      <div className="h-40 flex items-end justify-around mb-2">
        <div className="w-10 bg-blue-500 h-24"></div>
        <div className="w-10 bg-blue-500 h-32"></div>
        <div className="w-10 bg-blue-500 h-16"></div>
        <div className="w-10 bg-blue-500 h-28"></div>
        <div className="w-10 bg-blue-500 h-12"></div>
      </div>
      
      <div className="flex justify-between text-xs text-gray-500 mb-3">
        <span>Mon</span>
        <span>Tue</span>
        <span>Wed</span>
        <span>Thu</span>
        <span>Fri</span>
      </div>
      
      <div className="space-y-1 text-sm">
        <div className="flex justify-between">
          <span>New consults:</span>
          <span className="text-green-500 font-medium">+5%</span>
        </div>
        <div className="flex justify-between">
          <span>Follow-ups:</span>
          <span className="text-green-500 font-medium">+2%</span>
        </div>
      </div>
    </div>
  );
};

export default ClinicalActivity;